<template>
  <div>
    <activity-redirect-to-office></activity-redirect-to-office>
    <tool-bar :title="title" :show-right-menu="false" :showSubTitle="false"></tool-bar>
    
    <weex-image
      :src="ezCredLogoSrc"
      class="horizontal_center margin_top_20"
      style="height: 20px;"
    ></weex-image>

    <weex-image
      :src="applyLoanImageSrc"
      class="horizontal_center margin_top_40"
      style="height: 180px;width: 150px;"
    ></weex-image>

    <div class="margin-top-30 margin-left-10 margin-right-10">
      <weex-text
        class="margin-top-20 text-align-center font-size-xl font-weight-bold text-color-blue"
        v-html="letsGetStart"
        style="line-height:120%;"
      ></weex-text>

      <weex-text
        v-if="applyLoanDescription"
        class="margin-top-20 text-align-center font-size-base text-color-gray"
        v-html="applyLoanDescription"
      ></weex-text>

      <instructions-item
        v-if="getInstructions.length"
        class="margin-top-10"
        :instructions="getInstructions"
        :use-bullet-for-indexing="true"
      ></instructions-item>
    </div>

    <wxc-button v-if="showCheckEligibiltyButton"
      :text="checkEligiblityButtonText"
      class="horizontal-center margin-top-40 margin-bottom-20"
      size="big"
      type="blue"
      @wxcButtonClicked="onContinue"
    ></wxc-button>

  </div>
</template>

<script>
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
import ActivityNavigator, { Activities } from "../../utils/ActivityNavigator";
import ToolBar from "../layout/ToolBar";
import EzUtils from "../../utils/EzUtils";
import UrlParams from "../../data/model/UrlParams";
import InstructionsItem from "../layout/InstructionsItem";
import ActivityRedirectToOffice from "../layout/ActivityRedirectToOffice";
import CoBrandingDataHolder from '../../data/model/CoBrandingDataHolder';

const MERCHANT = "MERCHANT";

export default {
  name: "WelcomeActivity",
  components: { ToolBar, WxcButton, InstructionsItem,ActivityRedirectToOffice },
  data: () => ({}),

  methods: {
    onContinue() {
      ActivityNavigator.navigateTo(Activities.LOGIN);
    }
  },

  computed: {
    isOnboardingProcess() {
      return EzUtils.areEqualString(MERCHANT, UrlParams.getEntity(), true)
        ? true
        : false;
    },

    title() {
      return this.isOnboardingProcess ? "Welcome to Dealer Onboarding" : "Welcome";
    },

    letsGetStart() {
      return this.isOnboardingProcess
          ? "EzCred  - Lending Platform for Purchase Financing"
          : (UrlParams.getMerchantID() || EzUtils.isValidId(UrlParams.getLeadId()))
              ? "Let's Get Started" : "Welcome to EzCred";

    },

    applyLoanDescription() {
      return this.isOnboardingProcess ? 
      `<span style="font-weight: bold;">Easy onboarding</span><span> process in 2-3 minutes, a simple application process to sign up with EzCred.</span>` 
      : (UrlParams.getMerchantID() || EzUtils.isValidId(UrlParams.getLeadId()))
          ? `<span style="font-weight: bold;">Easy Instant Loan</span><span> in 3-5 minutes. A simple application process to know your eligibility and get credit instantly.</span>`
          : "";
    },

    applyLoanImageSrc() {
      return ImageResourcesUtil.getImageLink(ImageResourcesUtil.APPLY_LOAN);
    },

    ezCredLogoSrc() {
      return ImageResourcesUtil.getImageLink(ImageResourcesUtil.EZCRED_COLOR_LOGO_WITH_NAME);
    },

    getInstructions() {
      return (UrlParams.getMerchantID() || EzUtils.isValidId(UrlParams.getLeadId()))
              ? []
              : [
                `<span style="color: #000000">Thanks for showing interest in EzCred for Loan Application.</span>`,
                `<span style="color: #000000">The web link used to process the Loan Application is not correct. You are only allowed to view existing loans.</span>`,
                `<span style="color: #000000">To create a new loan please get the correct URL from your Partner or contact EzCred Support for further steps.</span>`,
              ];
    },

    checkEligiblityButtonText() {
      return this.isOnboardingProcess ? "Sign up" : "Check Eligibility";
    },

    showCheckEligibiltyButton(){
      return CoBrandingDataHolder.isURLValid();
    }

  }
}
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
